import React from "react";

function Hero() {
  return (
    <section className="hero">
      <div className="hero-content">
        {/* <h2>
          The Fastest Professional Reel Service
        </h2> <br /><br />
        <h2>
          Shoot, Edit & Post in
        </h2> <br /><br />
        <h1>10  Minutes!</h1> */}



        <h1>
          Just <span className="highlight">Reel</span> it for all your <br />
          Weddings with <span className="highlight">ReelOnGo</span>
        </h1>

        <p>
          India’s First & Fastest Event Content Service — Shoot, Edit & Post in
          Minutes!
        </p>

        <div className="hero-buttons">
          <button className="primary">Book Now</button>
          {/* <button className="secondary">Become a Creator</button> */}
        </div>
      </div>
    </section>
  );
}

export default Hero;
